<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">{{$route.name}}</h4>
						<!-- <p class="category">{{$route.name}}</p> -->
					</md-card-header>
					<md-card-content>
						<router-view />
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		mounted() {
			if (!this.allow_user('ac')) { this.$router.push("/404"); }
			if (this.$store.state.authentication.mode != "normal") { this.$router.push("/404"); }
		},
		data() {
			return {
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/AccountantsPayments.vue